// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__CmtLf","image":"styles_image__2lina","number":"styles_number__3kN1Q","info":"styles_info__31_0L"};